<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">疫苗驱虫列表</div>
        <div class="titleR">
          <!-- <div class="titleRText" @click="toYmqcPackageList">疫苗驱虫套餐查询</div> -->
        </div>
      </div>
      <div class="content">
        <div class="con">
          <div class="tabLine">
            <div class="tabLineL">
              <div
                class="tabItem"
                :class="[tabIndex === 0 ? 'active' : '']"
                @click="changeTabIndex(0)"
              >
                全部
              </div>
              <div
                class="tabItem"
                :class="[tabIndex === 1 ? 'active' : '']"
                @click="changeTabIndex(1)"
              >
                待完成
              </div>
              <div
                class="tabItem"
                :class="[tabIndex === 2 ? 'active' : '']"
                @click="changeTabIndex(2)"
              >
                已完成
              </div>
              <div
                class="tabItem"
                :class="[tabIndex === 3 ? 'active' : '']"
                @click="changeTabIndex(3)"
              >
                已失效
              </div>
            </div>
            <div class="tabLineR">
              <el-button
                type="warning"
                size="small"
                @click="toAdd"
                style="width: 116px"
                >新增</el-button
              >
            </div>
          </div>
          <div class="searchLine">
            <div class="searchLineL">
              <el-input
                style="width: 180px; margin-right: 10px"
                placeholder="请输入顾客名称或手机号"
                v-model="search.keyword"
                @keyup.enter.native="clickSearch"
                clearable
                size="small"
              ></el-input>
              <el-button @click="clickSearch" type="warning" size="small"
                >搜索</el-button
              >
              <div class="searchLabel">选择门店</div>
              <el-select
                style="width: 120px"
                v-model="search.shopId"
                placeholder="请选择"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in shopsList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
              <div class="searchLabel">宠物类别</div>
              <el-select
                style="width: 100px"
                v-model="search.petType"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: '' },
                    { label: '犬类', value: '犬类' },
                    { label: '猫类', value: '猫类' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="searchLabel">服务类型</div>
              <el-select
                style="width: 100px"
                v-model="search.serviceTypeId"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: 0 },
                    { label: '疫苗', value: 1 },
                    { label: '驱虫', value: 2 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="searchLabel">支付状态</div>
              <el-select
                style="width: 100px"
                v-model="search.isPay"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: -1 },
                    { label: '未支付', value: 0 },
                    { label: '已支付', value: 1 },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchLineR"></div>
          </div>
          <div class="elTable">
            <el-table :data="tableData" style="width: 100%" height="100%">
              <el-table-column label="单号" prop="id" min-width="105">
                <template slot-scope="props">
                  <span>{{ props.row.id }}</span>
                  <span v-if="props.row.oneSelf" style="color: rgb(253, 78, 78)"
                    >(自用)</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="类别" prop="recordId" min-width="45">
                <template slot-scope="props">
                  <span v-if="props.row.serviceTypeId === 1">疫苗</span>
                  <span v-if="props.row.serviceTypeId === 2">驱虫</span>
                </template>
              </el-table-column>
              <el-table-column
                label="套餐名称"
                prop="servicePackageName"
                min-width="130"
              >
              </el-table-column>
              <el-table-column label="顾客" prop="memberName" min-width="70">
              </el-table-column>
              <el-table-column
                label="手机号"
                prop="memberMobile"
                min-width="95"
              >
              </el-table-column>
              <el-table-column label="昵称" prop="petName" min-width="70">
              </el-table-column>
              <el-table-column label="品种" prop="typeName" min-width="60">
              </el-table-column>
              <el-table-column label="年龄" prop="birthDay" min-width="70">
                <template slot-scope="props">
                  <span
                    >{{
                      $public.FAge(new Date(props.row.birthDay).getTime())[0]
                    }}岁</span
                  >
                  <span
                    >{{
                      $public.FAge(new Date(props.row.birthDay).getTime())[1]
                    }}月</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="下次计划时间" min-width="95">
                <template slot-scope="props">
                  <div v-if="props.row.payType === 2" style="color: #bb6508">
                    {{ $public.FTime(props.row.planNextDate, "YYYY-MM-DD")
                    }}<br />{{ props.row.serviceStatus === 2 ? "已失效" : "" }}
                  </div>
                  <div v-else>
                    {{ $public.FTime(props.row.planNextDate, "YYYY-MM-DD")
                    }}<br />{{ props.row.serviceStatus === 2 ? "已失效" : "" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="支付方式" min-width="70">
                <template slot-scope="props">
                  <span v-if="props.row.payType === 1">全额支付</span>
                  <span v-if="props.row.payType === 2">计划支付</span>
                  <span v-if="props.row.payType === 3">套餐卡</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="支付状态" min-width="70">
								<template slot-scope="props">
									<div v-if="props.row.payType==1||props.row.payType==3">
										<span style="color:#FD4E4E" v-if="props.row.isPay==0">未支付</span>
										<span style="color:#18A44C" v-if="props.row.isPay==1">已支付</span>
									</div>
									<div v-if="props.row.payType==2">
										<span >{{props.row.payInfo.payCount}}</span>
										<span >/{{props.row.payInfo.total}}</span>
									</div>
								</template>
							</el-table-column> -->
              <el-table-column label="完成情况" min-width="70">
                <template slot-scope="props">
                  <span style="color: #18a44c">{{
                    props.row.completeCount
                  }}</span
                  >/<span>{{ props.row.planCount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建门店" min-width="70">
                <template slot-scope="props">
                  <span>{{ $public.getShopNameById(props.row.shopId) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" min-width="90">
              </el-table-column>
              <el-table-column label="操作" min-width="120">
                <template slot-scope="props">
                  <el-button type="text" size="mini" @click="toSee(props.row)"
                    >查看</el-button
                  >
                  <el-button
                    v-show="$buttonAuthority('yewu-yiliaoxin-editquchong')"
                    type="text"
                    @click="toEdit(props.row)"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-show="
                      $buttonAuthority('yewu-yiliaoxin-delquchong')
                    "
                    type="text"
                    @click="del(props.row)"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageBox">
          <page
            style="padding: 10px 0"
            :total="page.total"
            :page="page.page"
            @change="changePage"
          ></page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
export default {
  components: { page },
  data() {
    return {
      shopsList: [],
      // datetimerange:'',
      search: {
        serviceTypeId: 0, // 0全部 1疫苗；2驱虫;
        payType: 0, // 0全部 1全额支付；2计划支付 3套餐卡
        isPay: -1, // 是否支付
        isComplete: -1,
        serviceStatus: -1,
        petType: "", // 犬类 猫类
        keyword: "",
        shopId: this.$store.state.shopId,
        begin_time: "",
        end_time: "",
      },
      // search1:{
      // 	"categoryName": '',  // 类型：犬类；猫类
      // 	"serviceType": '',  // 类型：疫苗；驱虫
      // 	keyword:'',
      // },
      tableData: [],
      tabIndex: 0,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
    ymqcParams() {
      return this.$store.state.yiliaoxin.ymqcParams;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.page.page === 1) {
        vm.getTableData();
      }
    });
  },
  created() {
    this.page.page = this.ymqcParams.curPage || 1;
    let shopsList = JSON.parse(JSON.stringify(this.$store.getters["shopList"]));
    if (shopsList[0] && shopsList[0].shop_name !== "全部") {
      shopsList.unshift({ shop_id: "", shop_name: "全部" });
    }
    this.shopsList = shopsList;
  },
  mounted() {
    this.tabIndex = this.ymqcParams.initialDataOflist.tabIndex || this.tabIndex;
    this.search = this.ymqcParams.initialDataOflist.search || this.search;
    this.page = this.ymqcParams.initialDataOflist.page || this.page;
    this.getTableData();
  },
  methods: {
    // 跳转
    toYmqcPackageList() {
      this.ymqcParams.type = "packageList";
      this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
    },
    toAdd() {
      this.ymqcParams.type = "add";
      this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
      this.$store.commit("yiliaoxin/add_router", {
        name: "疫苗驱虫",
        data: this.ymqcParams,
      });
    },
    toEdit(row) {
      this.ymqcParams.curRow = row;
      this.ymqcParams.type = "edit";
      this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
      this.$store.commit("yiliaoxin/add_router", {
        name: "疫苗驱虫",
        data: this.ymqcParams,
      });
    },
    toSee(row) {
      this.ymqcParams.curRow = row;
      this.ymqcParams.type = "see";
      // this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
      // this.$store.commit("yiliaoxin/add_router", {
      //   name: "疫苗驱虫",
      //   data: this.ymqcParams,
      // });  
    },
    reset() {
      this.search.petType = "";
      this.search.serviceTypeId = 0;
      this.search.isPay = -1; // 是否支付
      this.search.keyword = "";
      this.search.shopId = "";
      this.page.page = 1;
      this.getTableData();
    },
    clickSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 改变分页
    changePage(num) {
      this.ymqcParams.curPage = num;
      this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
      this.page.page = num;
      this.getTableData();
    },
    // 删除
    del(row) {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete("/api/MedicalPackage/Delete", { serviceId: row.id })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getTableData();
            }
          });
      });
    },
    // 切换列表
    changeTabIndex(index) {
      this.tabIndex = index;
      if (index == 0) {
        this.search.isComplete = -1;
        this.search.serviceStatus = -1;
      } else if (index == 1) {
        this.search.isComplete = 0;
        this.search.serviceStatus = 1;
      } else if (index == 2) {
        this.search.isComplete = 1;
        this.search.serviceStatus = -1;
      } else if (index == 3) {
        this.search.isComplete = -1;
        this.search.serviceStatus = 2;
      }
      this.page.page = 1;
      this.getTableData();
    },
    getTableData() {
      let loading = this.$loading();
      let params = {
        serviceTypeId: this.search.serviceTypeId, // 0全部 1疫苗；2驱虫;
        payType: this.search.payType, // 1全额支付；2计划支付 3套餐卡
        isPay: this.search.isPay, // -1全部 0未支付 1已支付
        isComplete: this.search.isComplete, //-1全部；0待完成；1已完成
        serviceStatus: this.search.serviceStatus, //-1全部；1正常；2失效
        petType: this.search.petType, // 犬类 猫类
        petId: "",
        desc: true,
        shopId: this.search.shopId,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.search.keyword,
      };
      // if(this.datetimerange&&this.datetimerange.length==2){
      // 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
      // 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
      // }
      this.$http.post("/api/MedicalPackage/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.page.total = res.data.count;
          this.replaceRouter();
        }
      });
    },
    replaceRouter() {
      this.ymqcParams.initialDataOflist = {
        tabIndex: this.tabIndex,
        search: this.search,
        page: this.page,
      };
      this.$store.commit(
        "yiliaoxin/set_ymqcParams",
        JSON.parse(JSON.stringify(this.ymqcParams))
      );
      this.$store.commit("yiliaoxin/replace_router", {
        name: "疫苗驱虫",
        data: JSON.parse(JSON.stringify(this.ymqcParams)),
      });
    },
    getTableData1() {
      // let loading=this.$loading();
      // let params = {
      // 	"categoryName": this.search1.categoryName,  // 类型：犬类；猫类
      // 	"serviceType": this.search1.serviceType,   // 类型：疫苗；驱虫
      // 	"pageIndex": this.page1.page,
      // 	"pageSize": this.page1.pageSize,
      // 	"keyword": this.search1.keyword,
      // }
      // this.$http.get('/api/ServicePackages/List', params).then(res => {
      // 	loading.close()
      // 	if (res.code == 0) {
      // 		this.tableData1 = res.data.data;
      // 		this.page1.total = res.data.count;
      // 	}
      // })
    },
  },
  // beforeDestroy(){
  // 	this.ymqcParams.initialDataOflist = {
  // 		tabIndex:this.tabIndex,
  // 		search:this.search,
  // 		page:this.page,
  // 	}
  // 	this.$store.commit("yiliaoxin/set_ymqcParams",JSON.parse(JSON.stringify(this.ymqcParams)))
  // },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      position: relative;
      padding: 0px 0 50px;
      width: 100%;
      height: calc(100% - 47px);
      box-sizing: border-box;
      .con {
        width: 100%;
        height: 100%;
        .tabLine {
          height: 60px;
          padding: 16px 20px 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .tabLineL {
            display: flex;
            .tabItem {
              width: 90px;
              text-align: center;
              line-height: 32px;
              border-radius: 19px;
              background-color: #f7f7f7;
              color: #73737b;
              font-size: 14px;
              margin-right: 20px;
              border: 1px solid transparent;
              cursor: pointer;
              font-weight: bold;
              &.active {
                color: $mainColor;
                background-color: #fff9f3;
                border-color: $mainColor;
              }
            }
          }
          .tabLineR {
          }
        }
        .searchLine {
          padding: 8px 20px 20px;
          box-sizing: border-box;
          display: flex;
          .searchLineL {
            display: flex;
            .searchLabel {
              font-size: 14px;
              margin-right: 5px;
              color: $fontColor;
              line-height: 32px;
              margin-left: 10px;
            }
          }
          .searchLineR {
          }
        }
        .elTable {
          height: calc(100% - 121px);
        }
      }
      .pageBox {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>
